import { Outlet, Navigate } from "react-router-dom";

const NonAuthRoutes = () => {
	let auth = { token: localStorage.getItem("token") };
	return !auth.token ? <Outlet /> : <Navigate to="/" />;
};

export default NonAuthRoutes;
